import Link from 'next/link';

import styled from 'styled-components';

import { SPACING } from '~/common/layout-propertis/spacing';

export const StyContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${SPACING._16};
`;

export const StySeparator = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${SPACING._10};
`;

export const StyLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.neutral[700]};
`;

export const StyOthersSignIn = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${SPACING._8};
`;

export const StyOpenAccount = styled.div`
  padding-top: ${SPACING._16};
`;

export const StyCreateAccount = styled.div`
  width: fit-content;
  display: flex;
  align-items: center;
  flex-direction: row;
  cursor: pointer;
  gap: ${SPACING._4};

  &:hover {
    span {
      text-decoration: underline;
    }
  }
`;

export const StyBackLogin = styled(Link)`
  width: fit-content;
  display: flex;
  align-items: center;
  flex-direction: row;
  cursor: pointer;
  gap: ${SPACING._4};
  margin-top: ${SPACING._16};

  &:hover {
    span {
      text-decoration: underline;
    }
  }
`;

export const StyTerms = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${SPACING._8};
  align-items: center;
  width: 100%;
`;

export const StyPrivacity = styled.div`
  display: flex;
  cursor: pointer;
  &:hover {
    span {
      text-decoration: underline;
    }
  }
`;

export const StyFormSignup = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${SPACING._16};
`;

export const StyTermsContent = styled.div``;

export const StyInvalidTerms = styled.div``;

export const StyAlignSuccess = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
